import { GAP_SIZE, ROW_HEIGHT } from '@neptune/shared/grid-layout-domain';

export const BOTTOM_PINNED_WIDGET_LEGEND_GRID_ROWS = 4;

export const BOTTOM_PINNED_WIDGET_LEGEND_HEIGHT_PX =
  BOTTOM_PINNED_WIDGET_LEGEND_GRID_ROWS * (ROW_HEIGHT + GAP_SIZE);

export const SCREENSHOT_MODE_LEGEND_GRID_ROWS = 4;
export const SCREENSHOT_MODE_LEGEND_HEIGHT_PX =
  SCREENSHOT_MODE_LEGEND_GRID_ROWS * (ROW_HEIGHT + GAP_SIZE);
